import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DownloadButton from 'components/IconButton/DownloadButton';
import staticText from 'static/text_display.json';
import { useTranslation } from 'react-i18next';
import { actions as templateActions } from '../Modules/dataGridTable';
import * as templateSelectors from '../Selectors/templateSelectors';

const TaskManagerial = ({ id, fetchTemplateTaskQr, details, className }) => {
  const { t } = useTranslation();
  const downloadQr = () => {
    fetchTemplateTaskQr({ id });
  };
  const getTitleValue = type => {
    if (Object.keys(details).length < 1) {
      return type === staticText.general.edit
        ? staticText.cleaner_operational_view.task.edit_default
        : staticText.cleaner_operational_view.task.download_default;
    }

    return details.generalInfo.taskName.value;
  };

  const convertedText = t('download_qrcode_operational', {
    value: getTitleValue(staticText.general.download),
  });

  return (
    <div className={className}>
      <label>{`${t('Download')} ${t('QR-code')}`}: </label>
      <DownloadButton title={convertedText} onClick={downloadQr} white />
    </div>
  );
};

const mapStateToProps = state => ({
  details: templateSelectors.getGridRowDetailsTransformed(state),
});

const mapDispatchToProps = dispatch => ({
  fetchTemplateTaskQr: ({ id }) => dispatch(templateActions.fetchQr({ id })),
});

TaskManagerial.propTypes = {
  id: PropTypes.string,
  details: PropTypes.object,
  fetchTemplateTaskQr: PropTypes.func,
  className: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskManagerial);
